import React from 'react';
import { Navigate } from 'react-router-dom';

const MapGuestList = () => {
  // @TODO: guest list page
  return <Navigate to="/login" />;
};

export default MapGuestList;
